// extracted by mini-css-extract-plugin
export var activityContainer = "_m9-0";
export var typingIndicatorContainer = "_m9-1";
export var typingIndicatorDot = "_m9-2";
export var wave = "_m9-3";